module.exports = __webpack_public_path__ + "static/media/Lucid.c1e4fb71.svg";